import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { ISaveLocation } from "../../interfaces/services";
import { EtyLocation } from "../../interfaces/entities";

import useToast from "../useToast";

import { saveLocation } from "../../services/locations";

export interface IPayload {
    payload: ISaveLocation;
    operation: string;
    setIsProcessing: Function;
};

export interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
    data: EtyLocation
};

const useSaveLocation = () => {
    const navigate = useNavigate();
    // const queryClient = useQueryClient();

    const { addToast } = useToast();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        return await saveLocation(data.payload);
    };

    return useMutation({
        mutationFn,
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response?.statusCode === 200) {
                addToast({
                    type: 'success',
                    title: 'Location details saved successfully.',
                });

                if (variables.operation === 'create') {
                    setTimeout(() => {
                        // navigate(`/employers/${response?.data?.employer_id}/locations/${response?.data.id}/details`);
                        navigate(`/employers/${variables.payload.employer_id}/locations`)
                    }, 500);
                } else {
                    // queryClient.invalidateQueries({ queryKey: ['location_details'] });
                    setTimeout(() => {
                        navigate(`/employers/${variables.payload.employer_id}/locations`)
                    }, 500);
                };
            };
        },
        onError: (error: IResponse, variables: IPayload) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error.message
            });
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useSaveLocation;